import { COMMON } from "../../util/localizations"
import { MAX_SUMMARY_LENGTH } from "./config"

const TRANSLATIONS = {
    en: {
        about: COMMON.en.about,
        addEvidence: 'Add Evidence',
        alertTitle: 'Evidence Persistence',
        allowedDomains: 'The following archives are allowed: ',
        badUrl: 'The entered URL is either malformatted or unallowed.',
        cancel: COMMON.en.cancel,
        commit: 'Commit Changes',
        delete: 'I understand',
        evidence: COMMON.en.evidence,
        failBadData: 'The evidence you submitted contains erroneous data. Please correct it or remove it.',
        failNoData: 'Some of the evidence you submitted is blank. Please fill it in or remove it.',
        instructions: `Clicking the, "{0}" button below will permanently delete this node and all of its connections. You will not be able to undo this action.`,
        maxLength: `{0}/${ MAX_SUMMARY_LENGTH } Characters.`,
        name: 'Name',
        note: `Evidence URLs are restricted to archiving websites. See the, "{0}" page for more information.`,
        explanation: 'Explanation of Relevance',
        title: 'Manage Evidence for "{0}"',
        url: 'Source URL',
        warning: 'Please read before continuing'
    }
}

export default TRANSLATIONS